module.exports = __webpack_public_path__ + "img/22.26571d2f.jpg";